export const PROPERTY_PREVIEW = "PROPERTY_PREVIEW"
export const PROPERTY_UPDATE = "PROPERTY_UPDATE"
export const PROPERTY_PROCESS_SUCCESS = "PROPERTY_PROCESS_SUCCESS"
export const PROPERTY_DATASOURCE_SUCCESS = "PROPERTY_DATASOURCE_SUCCESS"
export const PROPERTY_PROCESS_RESET = "PROPERTY_PROCESS_RESET"

export interface PropertyRequest {
  type: typeof PROPERTY_PREVIEW
}
export interface PropertyUpdate {
  type: typeof PROPERTY_UPDATE,
  payload?: any
}
export interface PropertyDataSourceSuccess{
  type: typeof PROPERTY_DATASOURCE_SUCCESS,
  payload:any
}
export interface PropertyProcessSuccess {
  type: typeof PROPERTY_PROCESS_SUCCESS,
  payload:any
}
export interface PropertyProcessReset{
  type: typeof PROPERTY_PROCESS_RESET
}

export type PropertyAction = 
| PropertyRequest
| PropertyUpdate
| PropertyDataSourceSuccess
| PropertyProcessSuccess
| PropertyProcessReset